var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0625 0.156227C0.90625 -2.28882e-05 0.6875 -2.28882e-05 0.53125 0.156227L0.3125 0.374977C0.15625 0.531227 0.15625 0.749977 0.3125 0.906227L6.40625 6.99998L0.3125 13.125C0.15625 13.2812 0.15625 13.5 0.3125 13.6562L0.53125 13.875C0.6875 14.0312 0.90625 14.0312 1.0625 13.875L7.65625 7.28123C7.8125 7.12498 7.8125 6.90623 7.65625 6.74998L1.0625 0.156227ZM4.53125 0.156227L4.3125 0.374977C4.15625 0.531227 4.15625 0.749977 4.3125 0.906227L10.4062 6.99998L4.3125 13.125C4.15625 13.2812 4.15625 13.5 4.3125 13.6562L4.53125 13.875C4.6875 14.0312 4.90625 14.0312 5.0625 13.875L11.6562 7.28123C11.8125 7.12498 11.8125 6.90623 11.6562 6.74998L5.0625 0.156227C4.90625 -2.28882e-05 4.6875 -2.28882e-05 4.53125 0.156227Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowRight);
export default __webpack_public_path__ + "static/media/DoubleArrowRight.7cde90a40be4536b1ac34e17c83d6dbf.svg";
export { ForwardRef as ReactComponent };